var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#searchIconWhite_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.091 26.22v0l.004-.004a.58.58 0 00.155-.423.56.56 0 00-.155-.395l-3.336-3.336a.533.533 0 00-.269-.142c.304-.42.544-.886.736-1.397.256-.655.4-1.341.4-2.085 0-1.086-.287-2.058-.798-2.966l-.003-.006a6.07 6.07 0 00-2.166-2.165v0l-.005-.003c-.909-.511-1.88-.798-2.966-.798a6.03 6.03 0 00-2.994.798l-.005.003a5.788 5.788 0 00-2.14 2.168c-.542.915-.799 1.888-.799 2.969 0 1.08.256 2.08.8 2.996a5.53 5.53 0 002.142 2.142c.915.543 1.916.8 2.996.8.711 0 1.397-.115 2.084-.372l.003-.001a6.24 6.24 0 001.394-.769c.02.098.064.196.143.275h0l3.32 3.294c.04.055.094.11.17.147a.53.53 0 00.241.05.583.583 0 00.42-.18l.628-.6zm-4.846-5.72l-.002.003a4.029 4.029 0 01-1.492 1.518 4.182 4.182 0 01-2.063.542 4.035 4.035 0 01-2.062-.54l-.004-.003a3.91 3.91 0 01-1.517-1.517h0l-.002-.004a4.035 4.035 0 01-.54-2.061c0-.722.18-1.418.541-2.064a4.029 4.029 0 011.518-1.491l.004-.003a4.058 4.058 0 012.062-.567c.716 0 1.412.204 2.063.568a4.16 4.16 0 011.493 1.493c.364.652.569 1.348.569 2.064 0 .745-.206 1.44-.568 2.061z",
    fill: "url(#searchIconWhite_svg__a)",
    stroke: "url(#searchIconWhite_svg__a)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "searchIconWhite_svg__b",
    x1: 40,
    x2: 0,
    y1: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "searchIconWhite_svg__a",
    x1: 27,
    x2: 13,
    y1: 26.75,
    y2: 26.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })))));
}

export default SvgSearchIconWhite;